import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { CoolerCpu } from '../model/CoolerCpu';
import { Gabinete } from '../model/Gabinete';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_CoolerCpuGabinete extends FuncionCompatilibidadBase<CoolerCpu, Gabinete> {
  funciones = {
    altura: (coolerCpu: CoolerCpu, gabinete: Gabinete): Incompatibilities | null =>
      coolerCpu.$caracteristicas.altura_real > gabinete.$caracteristicas.altura_ccpu ?
        {
          tipo: IncompatibilitiesType.PRODUCTO,
          incompatibility: 'El gabinete y el coolerCpu no son compatibles por la altura ',
        }
      : null,
    waterCooling: (coolerCpu: CoolerCpu, gabinete: Gabinete): Incompatibilities | null =>
      (
        coolerCpu.$caracteristicas.tipo_disipacion == 'Watercooling' &&
        gabinete.$caracteristicas.cf_continuos_con_espacio_disipador == 0
      ) ?
        {
          tipo: IncompatibilitiesType.PRODUCTO,
          incompatibility:
            'El gabinete y el coolerCpu no son compatibles por el tipo de disipación ',
        }
      : null,
    espacio: (coolerCpu: CoolerCpu, gabinete: Gabinete): Incompatibilities | null => {
      let espacioCCPU = { clave: '', valor: 0 };
      if (coolerCpu.$caracteristicas.tipo_disipacion != 'Watercooling') return null;
      espacioCCPU =
        coolerCpu.$caracteristicas.espacios_120mm > 0 ?
          { clave: '120', valor: +coolerCpu.$caracteristicas.espacios_120mm }
        : { clave: '140', valor: coolerCpu.$caracteristicas.espacios_140mm };
      if (!espacioCCPU.valor)
        return {
          tipo: IncompatibilitiesType.PRODUCTO,
          incompatibility: `El gabinete y el coolerCpu no son compatibles`,
        };

      if (espacioCCPU.valor > 1) {
        return (
            !gabinete.$caracteristicas[`cf_${espacioCCPU.valor}x${espacioCCPU.clave}mm_continuos`]
          ) ?
            {
              tipo: IncompatibilitiesType.PRODUCTO,
              incompatibility: `El gabinete no tiene cf_${espacioCCPU.valor}x${espacioCCPU.clave}mm_continuos`,
            }
          : null;
      } else {
        return !gabinete.$caracteristicas[`cf_${espacioCCPU.clave}mm`] ?
            {
              tipo: IncompatibilitiesType.PRODUCTO,
              incompatibility: `El gabinete no tiene cf_${espacioCCPU.clave}mm`,
            }
          : null;
      }
    },
  };
}
